import { SelfUserDetailsType } from '@/api/v1/users/getSelfUserDetailsApi';
import capitalize from 'lodash/capitalize';

export const getInitials = (user: SelfUserDetailsType) => {
  const firstInitial = user.first_name?.charAt(0) ?? '';
  const lastInitial = user.last_name?.charAt(0) ?? '';

  return (firstInitial + lastInitial).toUpperCase();
};

export const getFullName = (user: SelfUserDetailsType) => {
  const first = capitalize(user.first_name ?? '');
  const last = capitalize(user.last_name ?? '');

  return [first, last].filter(Boolean).join(' ');
};
